import { render, staticRenderFns } from "./AuthorizationManagementView.vue?vue&type=template&id=8aec9618&scoped=true"
import script from "./AuthorizationManagementView.vue?vue&type=script&lang=js"
export * from "./AuthorizationManagementView.vue?vue&type=script&lang=js"
import style0 from "./AuthorizationManagementView.vue?vue&type=style&index=0&id=8aec9618&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aec9618",
  null
  
)

export default component.exports